import React from "react";
import { ArticleSkeleton } from "../../../components/Articles";
import { useSubcategoryArticles } from "../hooks/useSubcategoryArticles";
import { SubcategoryArticleList } from "./SubcategoryArticleList";
import { CategoryFallback } from "./CategoryFallback";

interface SubcategoryArticlesTabProps {
  id: number;
  enabled: boolean;
}

export const SubcategoryArticlesTab: React.FC<SubcategoryArticlesTabProps> = ({
  id,
  enabled,
}) => {
  const { articles, loading, error } = useSubcategoryArticles(id, {
    enabled,
  });

  if (!enabled) {
    return null;
  }

  if (loading) {
    return <ArticleSkeleton />;
  }

  if (error) {
    return <CategoryFallback />;
  }

  return (
    <SubcategoryArticleList
      articles={articles}
      data-id={`subcategory-article-list-${id}`}
    />
  );
};
